import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

export default function NotFound() {
    return (
        <Container className="gs-page">
            <div className="gs-page-gutter">
                <div className="gs-empty-state">
                    <h1>Page not found</h1>
                    <p>That URL doesn’t match anything on the site.</p>
                    <div className="gs-empty-state__actions">
                        <Link to="/" className="gs-btn">Back to Home</Link>
                        <Link to="/units" className="gs-btn gs-btn--ghost">Units</Link>
                        <Link to="/equips" className="gs-btn gs-btn--ghost">Equips</Link>
                    </div>
                </div>
            </div>
        </Container>
    );
}
